import { render, staticRenderFns } from "./ReactivatePlan.vue?vue&type=template&id=bd0fbdee&"
import script from "./ReactivatePlan.vue?vue&type=script&lang=js&"
export * from "./ReactivatePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports